import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const StickyIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" viewBox="0 0 48 48" {...props}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="M5 17C5 12 6 2 17 6c.946 3.782-2 11-12 11m38 0c0-5-1-15-12-11c-.946 3.782 2 11 12 11" />
        <rect width="32" height="20" x="8" y="22" fill="currentColor" rx="10" />
        <path d="M27 22v-4m-6 4v-4m22-1c1 3 1 9-3 12M5 17c-1 3 0 8 3 12m22 13h14l-4-9m-22 9H4l4-9" />
      </g>
    </svg>
  );
};

export default StickyIcon;
